import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Estrae SEMPRE un messaggio-stringa da un errore axios.
 *
 * Gestisce il caso del 422 di FastAPI dove `detail` è un array di oggetti
 * di validazione: passarlo direttamente a toast.error()/setMessage() farebbe
 * crashare React ("Objects are not valid as a React child") → white-screen.
 * Il classico `err.response?.data?.detail || "fallback"` NON basta perché un
 * array è truthy e viene passato così com'è.
 *
 * @param {*} err       errore axios (o qualsiasi cosa)
 * @param {string} fallback messaggio se detail assente
 * @returns {string}
 */
export function apiErr(err, fallback = "Errore") {
  // La rete e' caduta a metà richiesta e l'interceptor ha messo l'azione in coda:
  // NON e' un errore da rifare. Dirlo esplicitamente evita che l'operatore ripeta
  // l'operazione credendola persa — e crei un doppione.
  if (err?.queuedOffline) return "📵 Connessione persa — azione salvata e in attesa di sincronizzazione";
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((e) => e?.msg || (typeof e === "string" ? e : JSON.stringify(e))).join("; ");
  }
  if (d && typeof d === "object") return JSON.stringify(d);
  return d || fallback;
}

/**
 * Valida una password contro la policy backend (unica fonte:
 * `validate_password_policy` in server.py): >=8 caratteri, almeno un numero,
 * una lettera maiuscola e un carattere speciale.
 *
 * Tenere allineato col backend: se i controlli client divergono, l'utente
 * crea password che il frontend accetta ma il backend rifiuta con 422
 * (es. la pagina di reset finiva in errore mostrando "token non valido").
 *
 * @param {string} pwd
 * @returns {string|null} messaggio d'errore, o null se conforme
 */
export function passwordPolicyError(pwd) {
  if (!pwd || pwd.length < 8) return "La password deve essere di almeno 8 caratteri";
  if (!/\d/.test(pwd)) return "La password deve contenere almeno un numero";
  if (!/[A-Z]/.test(pwd)) return "La password deve contenere almeno una lettera maiuscola";
  if (!/[^A-Za-z0-9]/.test(pwd)) return "La password deve contenere almeno un carattere speciale";
  return null;
}
